/* Eligibility is computed by Liquid, not inferred from incomplete Ajax inventory. */
(function () {
  const requests = new Map();
  const root = () => window.Shopify?.routes?.root || '/';
  function handleOf(product) {
    if (product.handle) return product.handle;
    const path = (product.url || '').split('/products/')[1];
    return path ? decodeURIComponent(path.split(/[?#/]/)[0]) : null;
  }
  async function load(handle) {
    if (!handle) return null;
    if (!requests.has(handle)) {
      requests.set(handle, (async () => {
        const url = root() + 'products/' + encodeURIComponent(handle);
        const [ajax, visibility] = await Promise.all([
          fetch(url + '.js'), fetch(url + '?view=visibility')
        ]);
        if (!ajax.ok || !visibility.ok) throw new Error('Product verification failed');
        const product = await ajax.json();
        const policy = JSON.parse(await visibility.text());
        if (typeof policy.eligible_ids !== 'string' || !Array.isArray(policy.images)) {
          throw new Error('Visibility template is missing');
        }
        const originalVariants = product.variants;
        product.variants = originalVariants.filter(v => policy.eligible_ids.includes('|' + v.id + '|'));
        if (!product.variants.length) return null;
        const colorIndex = product.options.findIndex(option => /^(color|colour)$/i.test(typeof option === 'string' ? option : option.name));
        const images = policy.images;
        product.variants = product.variants.map(variant => {
          // A size without its own image may use an image from another size of the SAME color.
          const color = variant['option' + (colorIndex + 1)];
          const siblings = originalVariants.filter(v => colorIndex < 0 || v['option' + (colorIndex + 1)] === color);
          const image = images.find(img => String(img.id) === String(variant.featured_image?.id))
            || images.find(img => colorIndex >= 0 && (img.alt || '').trim().toLowerCase() === String(color).trim().toLowerCase())
            || images.find(img => siblings.some(v => String(v.featured_image?.id) === String(img.id)))
            || images[0];
          return { ...variant, featured_image: image || null };
        });
        product.images = images.map(img => img.src);
        product.featured_image = product.variants[0].featured_image?.src || images[0]?.src || null;
        product.image = product.featured_image;
        product.price = Math.min(...product.variants.map(v => v.price));
        product.price_min = product.price;
        product.price_max = Math.max(...product.variants.map(v => v.price));
        product.url = root() + 'products/' + product.handle + '?variant=' + product.variants[0].id;
        return product;
      })().catch(error => {
        requests.delete(handle);
        console.warn('Product visibility:', handle, error);
        return null;
      }));
    }
    return requests.get(handle);
  }
  async function verify(products) {
    return (await Promise.all((products || []).map(product => load(handleOf(product))))).filter(Boolean);
  }
  window.ProductVisibility = { load, verify };
  window.resolveProductVisibility?.();
})();
